
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Calendar, CreditCard, Users, Sparkles } from 'lucide-react';

const QuickActions = () => {
  const actions = [
    {
      title: "Book Treatment",
      description: "Schedule your next glow session",
      icon: <Calendar className="w-5 h-5" />,
      href: "/booking",
      className: "bg-gradient-to-br from-juv-terracotta to-juv-deep-chestnut text-white hover:shadow-terracotta"
    },
    {
      title: "Buy Credits",
      description: "Top up your glow balance",
      icon: <CreditCard className="w-5 h-5" />,
      href: "/credits/purchase",
      className: "bg-juv-soft-blush hover:bg-juv-rose-clay text-juv-deep-chestnut hover:shadow-rose-clay"
    },
    {
      title: "Refer Friends",
      description: "Earn $50 for each referral",
      icon: <Users className="w-5 h-5" />,
      href: "/referrals",
      className: "bg-juv-rose-clay hover:bg-juv-terracotta text-white hover:shadow-terracotta"
    },
    {
      title: "Take Quiz",
      description: "Find your perfect treatment",
      icon: <Sparkles className="w-5 h-5" />,
      href: "/quiz",
      className: "bg-gradient-to-br from-juv-rose-clay to-juv-terracotta text-white hover:shadow-glow"
    }
  ];

  return (
    <Card className="bg-white/90 backdrop-blur-luxury border border-juv-rose-clay/50">
      <CardHeader>
        <CardTitle className="text-juv-deep-chestnut">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {actions.map((action, index) => (
            <Button
              key={index}
              asChild
              className={`h-24 flex-col space-y-2 transition-all duration-300 ${action.className}`}
            >
              <Link to={action.href}>
                {action.icon}
                <div className="text-center">
                  <div className="font-medium text-sm">{action.title}</div>
                  <div className="text-xs opacity-80">{action.description}</div>
                </div>
              </Link>
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
